import styled from "styled-components";
import {HeaderNavbarMobileBaseBox} from "../../../boxes/header-navbar-mobile-base/header-navbar-mobile-base.box";

export const AppHeaderCrossBrandListDefaultBox = styled(HeaderNavbarMobileBaseBox)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 0;
`;
